{
  "name": "@texonom/cli",
  "displayName": "Notion CLI",
  "version": "1.6.10",
  "type": "module",
  "description": "Texonom CLI which has ability to export data from Notion.so",
  "repository": "texonom/notion-node",
  "author": "Seonglae Cho <sungle3737@gmail.com>",
  "license": "MIT",
  "main": "./build/src/main.js",
  "module": "./build/src/main.js",
  "types": "./build/src/main.d.ts",
  "sideEffects": false,
  "files": [
    "build"
  ],
  "engines": {
    "node": ">=22.23.3"
  },
  "bin": {
    "notion": "./build/src/main.js"
  },
  "scripts": {
    "build": "tsc && vite build",
    "watch": "vite build --watch --mode development",
    "test": "vitest --run",
    "prerelease": "standard-version --skip.changelog --prerelease",
    "release": "standard-version --release-as",
    "pu": "pnpm publish"
  },
  "dependencies": {
    "@texonom/nclient": "workspace:^",
    "@texonom/ntypes": "workspace:^",
    "@texonom/nutils": "workspace:^",
    "JSONStream": "^1.3.5",
    "clipanion": "^3.2.1",
    "graceful-fs": "^4.2.11",
    "prettier": "^3.9.9"
  },
  "standard-version": {
    "skip": {
      "commit": true,
      "tag": true
    }
  },
  "devDependencies": {
    "@types/graceful-fs": "^4.1.9",
    "@types/jsonstream": "^0.8.33"
  }
}
